import { createAsyncThunk } from "@reduxjs/toolkit";
import { get_basket } from "../../../../api/calls/basket/get_basket";
import { setMainModal } from "../../main";
import { setBasket } from "../basket";
import { calculate_basket_thunk } from "./calculate_basket_thunk";
export const get_basket_thunk = createAsyncThunk("basket/get_basket_thunk", async (arg, { dispatch, getState }) => {
    const state = getState();
    // console.log("get_basket_thunk STATE", state);
    const { user } = state.userState;
    const response = await get_basket({
        user_id: user.user._id,
    });
    // console.log("basket/get_basket_thunk", response);
    if (response.success) {
        if (response.content == null) {
            dispatch(setBasket(response.content));
        }
        else {
            await dispatch(calculate_basket_thunk(response));
        }
    }
    else {
        dispatch(setMainModal({ title: "Something went wrong while getting basket!", messages: [response.message] }));
    }
    return response;
});
